import React, { useEffect, useState, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import './style.css'
import L from 'leaflet';
import 'react-tooltip/dist/react-tooltip.css'
import { useMediaQuery } from 'react-responsive';
import { WiThermometer } from "react-icons/wi";
import { WiHumidity } from "react-icons/wi";
import { FaWind } from "react-icons/fa6";
import { WiBarometer } from "react-icons/wi";
import { FaCalendarAlt } from "react-icons/fa";
import { CgClose } from "react-icons/cg";
import Purpleairdata from './Purpleairdata';


const createCustomIcon = (aqi) => {
    const iconHtml = `
    <div class="custom-icon" style="background-color: ${getColorForAQI(aqi)};">
      <span>${aqi}</span>
    </div>
  `;
    return L.divIcon({
        className: "my-custom-icon",
        html: iconHtml,
        iconSize: L.point(40, 40),
    });
};

const getColorForAQI = (aqi) => {
    if (aqi <= 25) return '#009965';
    if (aqi <= 50) return '#76bb53';
    if (aqi <= 75) return '#fcde41';
    if (aqi <= 100) return '#fcbd3e';
    if (aqi <= 125) return '#fb9c3c';
    if (aqi <= 150) return '#e44e38';
    return '#cc0033';
};

const getTextForAQI = (aqi) => {
    if (aqi <= 25) return 'Good';
    if (aqi <= 50) return 'Fair';
    if (aqi <= 75) return 'Moderate';
    if (aqi <= 100) return 'Concerning';
    if (aqi <= 125) return 'Unhealthy for some';
    if (aqi <= 150) return 'Unhealthy for long term';
    return 'Unhealthy';
};

const getDescForAQI = (aqi) => {
    if (aqi <= 25) return 'Good';
    if (aqi <= 50) return 'Fair';
    if (aqi <= 75) return 'Moderate';
    if (aqi <= 100) return 'Concerning';
    if (aqi <= 125) return 'Unhealthy for some';
    if (aqi <= 150) return 'Unhealthy for long term';
    return 'Unhealthy';
};

const Legend = () => {
    const map = useMap();

    useEffect(() => {
        const legend = L.control({ position: 'bottomright' });

        legend.onAdd = function () {
            const div = L.DomUtil.create('div', 'info legend');
            const grades = ['Good', 'Fair', 'Moderate', 'Concerning', 'Unhealthy for some', 'Unhealthy for long term', 'Unhealthy'];
            const colors = ['#009965', '#76bb53', '#fcde41', '#fcbd3e', '#fb9c3c', '#e44e38', '#cc0033'];

            for (let i = 0; i < grades.length; i++) {
                div.innerHTML +=
                    '<i style="background:' + colors[i] + '; width: 18px; height: 18px; float: left; margin-right: 8px;"></i> ' +
                    grades[i] + '<br>';
            }
            return div;
        };

        legend.addTo(map);

        return () => {
            legend.remove();
        };
    }, [map]);

    return null;
};

function calculateAQI(pm25) {
    let aqi;
    if (pm25 <= 12) {
        aqi = linear(50, 0, 12, 0, pm25);
    } else if (pm25 <= 35.4) {
        aqi = linear(100, 51, 35.4, 12.1, pm25);
    } else if (pm25 <= 55.4) {
        aqi = linear(150, 101, 55.4, 35.5, pm25);
    } else if (pm25 <= 150.4) {
        aqi = linear(200, 151, 150.4, 55.5, pm25);
    } else if (pm25 <= 250.4) {
        aqi = linear(300, 201, 250.4, 150.5, pm25);
    } else if (pm25 <= 350.4) {
        aqi = linear(400, 301, 350.4, 250.5, pm25);
    } else if (pm25 <= 500.4) {
        aqi = linear(500, 401, 500.4, 350.5, pm25);
    } else {
        aqi = "Beyond the AQI scale";
    }
    return aqi;
}

function linear(AQIhigh, AQIlow, Conchigh, Conclow, Concentration) {
    const a = ((Concentration - Conclow) / (Conchigh - Conclow)) * (AQIhigh - AQIlow) + AQIlow;
    return Math.round(a);
}
const fetchAPI = async (url, headers = {}) => {
    try {
        const response = await fetch(url, { headers });
        if (!response.ok) {
            if (response.status === 429) {
               
                console.error("Rate limit exceeded, please try again later.");
            }
            throw new Error(`HTTP status ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error(`An error occurred: ${error.message}`);
        throw error; 
    }
};


const Map = () => {
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [map, setMap] = useState(null);


    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const center = [7.2955, 80.6356];
    const [sidebarStyle, setSidebarStyle] = useState({});
    const mapRef = useRef(null);

    const IQapiKey = '3421c2e7-23ed-4bfe-bc03-0825414993f2'; 

    const PurpleAirApiKey = 'FE15BB1B-F87E-11EE-B9F7-42010A80000D';

    useEffect(() => {
        const fetchCityData = async () => {
            const cities = [
                { city: 'Digana', state: 'Central', lat: 7.294184, lon: 80.738072 },
                { city: 'Dambulla', state: 'Central', lat: 7.86, lon: 80.65167 },
                { city: 'Negombo', state: 'Western', lat: 7.2166658, lon: 79.83333 },
                
            ];
            try {
                const cityResults = await Promise.all(cities.map(({ city, state, lat, lon }) =>
                    fetchAPI(`https://api.airvisual.com/v2/city?city=${city}&state=${state}&country=Sri Lanka&key=${IQapiKey}`)
                        .then(data => ({
                            name: city,
                            state: state,
                            lat: lat,
                            lon: lon,
                            data_time_stamp: data.data.current.pollution.ts,
                            aqius: data.data.current.pollution.aqius,
                            tp: data.data.current.weather.tp,
                            hu: data.data.current.weather.hu,
                            ws: data.data.current.weather.ws,
                            pr: data.data.current.weather.pr,
                        }))
                ));
                setLocations(prev => [...prev, ...cityResults]);
            } catch (error) {
                console.error('Failed to fetch city data:', error);
                setError(error.message);
            }
        };

        const fetchSensorData = async () => {
            const sensors = [
                { sensorIndex: 12451, lat: 7.2955, lon: 80.6356, name: 'Akurana', state: 'Central' },
                { sensorIndex: 29677, lat: 6.7051, lon: 79.9017, name: "Colombo Gregory's Road", state: 'Western' } ,
                { sensorIndex: 126417, lat: 8.031741, lon: 79.71905, name: "Norochcholai", state: 'North Western' }
            ];
            try {
                const sensorResults = await Promise.all(sensors.map(sensor =>
                    fetchAPI(`https://api.purpleair.com/v1/sensors/${sensor.sensorIndex}?fields=pm2.5,temperature,humidity,pressure`, { 'X-API-Key': PurpleAirApiKey })
                        .then(data => {
                            if (!data || !data.sensor) throw new Error("Sensor data is missing in response");
                            const temperatureF = data.sensor.temperature;
                            const temperatureC = (temperatureF - 32) * 5 / 9; // Convert F to C
                            const dataTimeStamp = data.data_time_stamp * 1000;
                            return {
                                ...sensor,
                                aqius: calculateAQI(data.sensor['pm2.5']),
                                tp: temperatureC.toFixed(1),
                                hu: data.sensor.humidity,
                                pr: data.sensor.pressure,
                                data_time_stamp: !isNaN(dataTimeStamp) ? new Date(dataTimeStamp).toISOString() : 'Invalid date',
                            };
                        })
                ));
                setLocations(prev => [...prev, ...sensorResults]);
            } catch (error) {
                console.error('Failed to fetch sensor data:', error);
                setError(error.message);
            }
        };


        fetchCityData();
        fetchSensorData().finally(() => setIsLoading(false));
    }, [IQapiKey, PurpleAirApiKey]);



    const formatDateTime = (dateString) => {
        if (!dateString) return "No date provided";

        const date = new Date(dateString);
        if (isNaN(date)) return "Invalid date";  // Check if the date is valid

        const optionsDate = { month: 'short', day: 'numeric', year: 'numeric' };
        const optionsTime = { hour: 'numeric', minute: 'numeric', hour12: true };

        const formattedDate = date.toLocaleDateString('en-US', optionsDate);
        const formattedTime = date.toLocaleTimeString('en-US', optionsTime);

        return `${formattedDate}, ${formattedTime}`;
    };

    const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1224px)' });
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' });
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' });
    const isTallScreen = useMediaQuery({ query: '(min-height: 850px)' });
    const isShortScreen = useMediaQuery({ query: '(max-height: 799px)' });

    useEffect(() => {
        let style = {};
        if (isBigScreen) {
            style = { width: '25%', fontSize: '16px' }; // Adjust for big screens
        } else if (isDesktopOrLaptop) {
            style = { width: '20%', fontSize: '16px' }; // Adjust for desktops and laptops
        } else if (isTabletOrMobile) {
            style = { width: '30%', fontSize: '14px' }; // Adjust for tablets and mobiles
        } else if (isPortrait) {
            style = { width: '50%', fontSize: '12px' }; // Adjust for portrait mode
        } else if (isRetina || isTallScreen || isShortScreen) {
            style = { width: '40%', fontSize: '10px' }; // Adjust for retina, tall screens, or short screens
        }
        setSidebarStyle(style);
    }, [isBigScreen, isDesktopOrLaptop, isTabletOrMobile, isPortrait, isRetina, isTallScreen, isShortScreen]);


    const handleMarkerClick = (location) => {
        setSelectedLocation(location);
    };

    /*useEffect(() => {
        if (mapRef.current) {
            console.log('Map OffsetTop:', mapRef.current.offsetTop);
            // Example: Add a class directly if needed (not typical React style)
            mapRef.current.classList.add('highlight-map');
        }
    }, [mapRef]);*/

    return (
        <>
            <div className="map-and-sidebar-container">
                <MapContainer className='map-container' center={center} zoom={7} style={{ height: '600px', width: '100%' }} ref={mapRef} whenCreated={setMap}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    {locations.map((location, index) => (
                        <Marker key={index} position={[location.lat, location.lon]} icon={createCustomIcon(location.aqius)} eventHandlers={{
                            click: () => handleMarkerClick(location),
                        }}>

                        </Marker>
                    ))}
                    <Legend />
                </MapContainer>
                {selectedLocation && (
                    <div className="sidebar" style={sidebarStyle}>
                        <div className='sidebar-header'>
                            <p className='airinfotext'>Air Quality information</p>
                            <CgClose className='close-icon' onClick={() => setSelectedLocation(null)} />
                        </div>
                        <div className='aqcontainer'>
                            <p className='locationname'>{selectedLocation.name}</p>
                            <p className='state'>{selectedLocation.state} Province, Sri Lanka</p>
                            <p className='datetime'><FaCalendarAlt /> {formatDateTime(selectedLocation.data_time_stamp)}</p>
                            <div className='aqicontainer'>
                                <div className='aqivalue' style={{ backgroundColor: getColorForAQI(selectedLocation.aqius), textAlign: 'center' }}>
                                    <p className='aqitext'>AQ Index</p>
                                    <p className='aqi'>{selectedLocation.aqius}</p>
                                    <p className='text'>{getTextForAQI(selectedLocation.aqius)}</p>
                                </div>
                                <div className='temp'>
                                    <p className='tempicon'><WiThermometer /></p>
                                    <p className='icon'>{selectedLocation.tp}°C</p>
                                </div>
                            </div>
                        </div>
                        <div className='conditionscon'>
                            <p className='conditions'>Conditions</p>
                            <div className='details'>
                                <div className='name'>
                                    <p className='name1'>Humidity</p>
                                    {selectedLocation.ws !== undefined && <p className='name2'>Wind</p>}
                                    <p className='name3'>Pressure</p>
                                </div>
                                <div className='variable'>
                                    <div className='icons'>
                                        <p className='hume'><WiHumidity /></p>
                                        {selectedLocation.ws !== undefined && <p className='wind'><FaWind /></p>}
                                        <p className='pressure'><WiBarometer /></p>
                                    </div>
                                    <div className='value'>
                                        <p className='value2'>{selectedLocation.hu}%</p>
                                        {selectedLocation.ws !== undefined && <p className='value3'>{selectedLocation.ws}km/h</p>}
                                        <p className='value4'>{selectedLocation.pr}mbar</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                )}

            </div>
        </>
    );
};

export default Map;
